import { useRef, useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";
import { CheckCircle2, Loader2, Upload } from "lucide-react";

export function FileDrop({ kind, label, hint, accept, value, onChange, required, testId }) {
  const ref = useRef(null); const [busy, setBusy] = useState(false); const [pct, setPct] = useState(0);
  const pick = async (e) => {
    const file = e.target.files?.[0]; if (!file) return;
    setBusy(true); setPct(0);
    const fd = new FormData(); fd.append("file", file);
    try {
      const r = await api.post(`/careers/upload?kind=${kind}`, fd, { onUploadProgress: (p) => setPct(Math.round((p.loaded / (p.total || file.size)) * 100)) });
      onChange(r.data.url, file.name); toast.success(`${label} uploaded`);
    } catch (err) { toast.error(err?.response?.data?.detail || `Could not upload ${label.toLowerCase()}`); }
    finally { setBusy(false); if (ref.current) ref.current.value = ""; }
  };
  return (
    <button type="button" onClick={() => ref.current?.click()} disabled={busy} className={`w-full text-left p-4 rounded-2xl border transition-colors ${value ? "border-emerald-400/40 bg-emerald-400/5" : "border-dashed border-slate-700 bg-[#0B0D12] hover:border-cyan-400/50"}`} data-testid={testId}>
      <input ref={ref} type="file" accept={accept} onChange={pick} className="hidden" data-testid={`${testId}-input`} />
      <div className="flex items-center gap-3">
        {busy ? <Loader2 className="w-5 h-5 text-cyan-300 animate-spin shrink-0" /> : value ? <CheckCircle2 className="w-5 h-5 text-emerald-300 shrink-0" /> : <Upload className="w-5 h-5 text-slate-400 shrink-0" />}
        <div className="min-w-0 flex-1">
          <p className="text-sm font-semibold">{label}{required && !value && <span className="text-rose-300"> *</span>}</p>
          <p className="text-xs text-slate-400 truncate" data-testid={`${testId}-status`}>{busy ? `Uploading… ${pct}%` : value ? value.name || "Uploaded" : hint}</p>
        </div>
      </div>
    </button>
  );
}
